import { render, staticRenderFns } from "./wipe_alerts.vue?vue&type=template&id=451aedf0"
import script from "./wipe_alerts.vue?vue&type=script&lang=js"
export * from "./wipe_alerts.vue?vue&type=script&lang=js"
import style0 from "./wipe_alerts.vue?vue&type=style&index=0&id=451aedf0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports